module.exports = __webpack_public_path__ + "img/dormakaba-component-lg.d8bea227.svg";